import classNames from "classnames";
import log from "cslog";
import React from "react";
// import Dropdown from "../../forms/elements/Dropdown";
import styles from "./styles/QFilters.module.css";
import {
    mobile,
    tablet,
    isHidden,
    parseStyle,
    decodeStyle,
} from "../../../../juntion";
import { useAtom } from "jotai";
import { filterPageState, usePageDbConfig } from "../../../../db";
import { useState } from "react";
import Chips from "./uis/Chips";
import MenuVertical from "./uis/MenuVertical";

function parseFilter(fcs) {
    if (fcs.allow_multiple) {
        // return makeSingleFilter(fcs.field, "_in", )
        return {
            field: fcs.field?.name,
            op: "_in",
            value: {
                type: "fixed",
                value: fcs.value,
            },
        };
    } else {
        if (fcs.value) {
            return {
                field: fcs.field?.name,
                op: "_eq",
                value: {
                    type: "fixed",
                    value: fcs.value,
                },
                subfield: fcs.field?.interface?.foreign_key_column,
                junctionfield: fcs.field?.interface?.junction_field,
            };
        }
        return null;
    }
}

function QFilters({ id, db, device, gs, dydb, ctx }) {
    const data = db[id];
    const [value, setValue] = useState(null);
    const [page_dbc, setPageDBC] = usePageDbConfig(ctx.page_id);
    // const [page_filter, setPageFilter] = useRecoilState(
    //     filterPageState(current_page?.id)
    // );

    //=========================
    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;

    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const fcs = input.filterConfigs;

    if (isHidden(ps.classes, device)) {
        return null;
    }
    return (
        <div>
            <FilterUI
                filterInterface={input.filterInterface}
                options={
                    fcs.options
                        ? [
                              { value: null, label: "All" },
                              ...fcs.options.filter((op) => op.label != ""),
                          ]
                        : []
                }
                // options={fcs.options.filter((op) => op.label != "") || []}
                multiple={fcs.allow_multiple}
                // value={fcs.value}
                value={value}
                setValue={(newVal) => {
                    const new_fcs = {
                        ...fcs,
                        value: newVal,
                    };
                    const parsed_filter = parseFilter(new_fcs);
                    setPageDBC({
                        ...page_dbc,
                        [new_fcs.source]: {
                            ...(page_dbc[new_fcs.source] || {}),
                            filter: parsed_filter,
                            page_no: 1,
                        },
                    });
                    setValue(newVal);
                }}
                styles_parsed={{
                    normal: decodeStyle(ps.style, gs),
                    hover: decodeStyle(ps.style__hover, gs),
                    selected: decodeStyle(ps.style__selected, gs),
                }}
                alignItems={input.alignItems}
            />
        </div>
    );
}

export default QFilters;

//==================================================
// type:
//   one_field: all filter options applies on one field only. like category
//   multi_field: all filter options applies on multiple fields. like one option on price, one on rating
// filter_type:
//   single: at a time only one filter option can be selected
//   multiple: multiple filter options can be selected
// options:
//   type:
//      fixed: user defined options
//      dynamic: options will be fetched from server
// interface:
//   dropdown
//   radio
//   toggle- (has attachement)(like gmail)
//   checkbox
//   chips
//   slider
//   range
//   date
//   hybrid
// remove_option_with_no_result: boolean (baad me lana hai, performance issue ke kaaran)

function FilterUI({
    filterInterface,
    options,
    value,
    setValue,
    multiple = false,
    styles_parsed,
    alignItems,
}) {
    const val = multiple ? (Array.isArray(value) ? value : []) : value;

    // log.d(options, "Options in Chips");

    const onChange = (newVal, index) => {
        // log.d(newVal, "Chips onChange");
        if (multiple) {
            if (val.includes(newVal)) {
                setValue(val.filter((item) => item !== newVal));
            } else {
                setValue([...val, newVal]);
            }
        } else {
            if (val === newVal) {
                setValue(null);
            } else {
                setValue(newVal);
            }
        }
    };
    // return (
    //     <>
    //         <Chips
    //             options={options}
    //             multiple={multiple}
    //             val={val}
    //             onChange={onChange}
    //             styles_parsed={styles_parsed}
    //             alignItems={alignItems}
    //         />
    //     </>
    // );

    if (filterInterface === "chips") {
        return (
            <Chips
                options={options}
                multiple={multiple}
                val={val}
                onChange={onChange}
                styles_parsed={styles_parsed}
                alignItems={alignItems}
            />
        );
    } else if (filterInterface === "menu_v") {
        return (
            <MenuVertical
                options={options}
                multiple={multiple}
                val={val}
                onChange={onChange}
                styles_parsed={styles_parsed}
                alignItems={alignItems}
                direction="v"
            />
        );
    } else if (filterInterface === "menu_h") {
        return (
            <MenuVertical
                options={options}
                multiple={multiple}
                val={val}
                onChange={onChange}
                styles_parsed={styles_parsed}
                alignItems={alignItems}
                direction="h"
            />
        );
    }
    return (
        <Chips
            options={options}
            multiple={multiple}
            val={val}
            onChange={onChange}
            styles_parsed={styles_parsed}
            alignItems={alignItems}
        />
    );
}

function Chips2({
    options,
    multiple,
    val,
    onChange,
    styles_parsed,
    alignItems,
}) {
    return (
        <div
            className={styles.chips_wrapper}
            style={{
                justifyContent: alignItems,
            }}
        >
            {options.map((option, index) => {
                if (option.label === "") {
                    return <></>;
                }
                const is_selected = multiple
                    ? val.includes(option.value)
                    : val === option.value;
                return (
                    <div
                        key={index}
                        className={styles.chips}
                        onMouseDown={() => onChange(option.value, index)}
                        style={{
                            ...styles_parsed.normal,
                            ...(is_selected ? styles_parsed.selected : {}),
                            cursor: "pointer",
                        }}
                    >
                        {option.label}
                    </div>
                );
            })}
        </div>
    );
}

// function DropdownFilter({ options, val, onChange }) {
//     return <Dropdown options={options} value={val} onChange={onChange} />;
// }
